export function highlightText(text, searchTerm) {
  if (!searchTerm) return text;
  const regex = new RegExp(`(${searchTerm})`, 'gi');
  return text.replace(regex, `<span class="highlight">$1</span>`);
}


export function truncateText(text, searchTerm, maxWords = 50) {
  if (!searchTerm) return text.split(' ').slice(0, maxWords).join(' ') + '...';

  const searchTermIndex = text.toLowerCase().indexOf(searchTerm.toLowerCase());
  if (searchTermIndex === -1) {
    // If the search term isn't found, return the first maxWords words
    return text.split(' ').slice(0, maxWords).join(' ') + '...';
  }

  // Find the start of the paragraph by searching for the nearest period before the search term index
  let paragraphStart = text.lastIndexOf('.', searchTermIndex) + 1;
  if (paragraphStart < 0) paragraphStart = 0; // If no period is found, start from the beginning

  // Extract text starting from the paragraph start
  const textFromParagraphStart = text.slice(paragraphStart).trim();
  
  // Truncate to maxWords from the paragraph start
  const truncatedText = textFromParagraphStart.split(' ').slice(0, maxWords).join(' ');
  
  // Check if the truncated text ends mid-sentence and append an ellipsis
  if (truncatedText.lastIndexOf('.') !== truncatedText.length - 1 && truncatedText.length < textFromParagraphStart.length) {
    return truncatedText + '...';
  }

  return truncatedText;
}